module.exports = __webpack_public_path__ + "img/04_uk.3320eadb.svg";